import React from 'react';

interface IProps {
  condition: boolean;
  wrapper: any;
  children: React.ReactElement;
}

export const ConditionalWrapper: React.FC<IProps> = ({ condition, wrapper, children }) => {
  return condition ? wrapper(children) : children;
};
